import { useState, useEffect } from 'react';
import { List } from 'immutable';
import _ from 'lodash';

import OrderActions from '../actions/OrderActions';
import UserStore from '../stores/UserStore';

const useChangeovers = (order) => {
    const [changeovers, setChangeovers] = useState(new List());
    const [isLoading, setIsLoading] = useState(false);
    const user = UserStore.getCurrent();

    const fetchChangeovers = async () => {
        setIsLoading(true);
        const data = await OrderActions.loadChangeovers(order, user.id);
        setChangeovers(data);
        setIsLoading(false);
    };

    useEffect(() => {
        if (user && user.isLoggedIn()) {
            _.defer(fetchChangeovers);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return { changeovers, isLoading };
};

export default useChangeovers;
